import { InjectionToken } from '@angular/core';

export const STAFF_SIGN_IN_ENABLED = new InjectionToken<boolean>('STAFF_SIGN_IN_ENABLED', {
    providedIn: 'root',
    factory: () => false,
});
